import axios from "axios";
import { Message } from "element-ui";
import store from "../store";
import { getToken } from "@/utils/auth";
import FileSaver from "file-saver";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 180000, // 请求超时时间
});
// request拦截器
service.interceptors.request.use(
  config => {
    // if (store.getters.token) {
    config.headers.Authorization = getToken();
    // }
    config.headers.xreferer = window.location.href;
    return config;
  },
  error => {
    // eslint-disable-next-line no-console
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.headers && response.headers["export"] === "export") {
      Message({
        message: "下载中...",
        type: "success",
        duration: 5 * 1000
      });

      let excelName = response.headers["filename"];
      let fileName = excelName === null ? "bmdl.xls" : decodeURI(excelName);
      let blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      });
      FileSaver.saveAs(blob, fileName);
      return;
    }
    /**
     * code业务处理，待开发
     */
    const res = response.data;
    // eslint-disable-next-line no-console
    if (res.code === 200) {
      return res;
    } else if (res.code === 401) {
      store.dispatch("system/logout", null, { root: true });
    } else {
      Message({
        message: res.message,
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(res);
    }
  },
  error => {
    const errorResponse = error.response;
    Message({
      message: errorResponse.data.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(errorResponse);
  }
);

export default service;
